import { render, staticRenderFns } from "./detailTIngbox.vue?vue&type=template&id=1b162b0a&scoped=true"
import script from "./detailTIngbox.vue?vue&type=script&lang=js"
export * from "./detailTIngbox.vue?vue&type=script&lang=js"
import style0 from "./detailTIngbox.vue?vue&type=style&index=0&id=1b162b0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b162b0a",
  null
  
)

export default component.exports